import React, { lazy } from 'react';
import { Star } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
const testimonialImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/xoouCRCG8S7RFbro2G1B6y/image.png',
  alt: 'Testimonio de WhatsApp - Mamá Carla feliz porque su hijo reconoció las letras'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rDXFJPQuB4zrqZ7usM9EZq/image.png',
  alt: 'Testimonio de paezalexia - Maravillosa atención, gran contenido, super recomendados'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bMENmZwEdJKrYm5VKXM7he/image.png',
  alt: 'Testimonio de politop1975 - Super buen material, lo recomiendo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uRMWNH6Pqgj7mm8iTfyB1w/image.png',
  alt: 'Testimonio - Un material muy práctico y llega enseguida'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hAPQkqPyRsNj9pn6EX2fmY/image.png',
  alt: 'Testimonio - Muy buen material y me lo enviaron de inmediato'
}];
const reviews = [{
  stars: 5,
  title: '¡Mi hijo lee solito!',
  text: 'A los 5 días ya reconocía todas las letras. Ahora me pide que le deje leer los cuentos a su hermanita. Se me salieron las lágrimas de la emoción.',
  name: 'Carla M.'
}, {
  stars: 5,
  title: 'Se acabó el llanto',
  text: 'Antes cada tarea de lectura terminaba en llanto. Con el MegaKit mi hijo piensa que está jugando, no estudiando. ¡Ese fue el cambio que necesitábamos!',
  name: 'Daniela R.'
}, {
  stars: 5,
  title: 'Resultados en una semana',
  text: 'No exagero: en 7 días mi hija pasó de trabarse en cada sílaba a leer oraciones completas. La maestra me preguntó qué estábamos haciendo diferente.',
  name: 'Paola G.'
}, {
  stars: 4,
  title: 'Como un juego para ellos',
  text: 'Lo mejor es que mi hijo no siente que es tarea. Él solito agarra las fichas y se pone a "jugar". Eso para mí no tiene precio.',
  name: 'Fernanda L.'
}, {
  stars: 5,
  title: 'Me quité un peso de encima',
  text: 'Tenía esa presión en el pecho cada vez que lo veía frustrarse. Ahora lee con una sonrisa y yo por fin respiro tranquila. Gracias infinitas.',
  name: 'Alejandra V.'
}, {
  stars: 5,
  title: 'Mejor que las clases particulares',
  text: 'Gasté mucho en clases extras y nada funcionaba. Este kit logró en días lo que no se logró en meses. Mi hija ahora ama leer.',
  name: 'Sofía T.'
}, {
  stars: 4,
  title: 'Lo recomiendo a todas las mamás',
  text: 'Se lo recomendé a tres amigas y todas me agradecieron. Sus hijos también mejoraron rapidísimo. Es un material muy bien pensado.',
  name: 'Mariana P.'
}, {
  stars: 5,
  title: 'Mi hijo recuperó la confianza',
  text: 'En el colegio le decían que iba lento y él se sentía mal. Con el MegaKit alcanzó a sus compañeros y ahora levanta la mano para leer en clase.',
  name: 'Gabriela S.'
}, {
  stars: 5,
  title: 'Llegó al instante',
  text: 'Lo compré y en minutos ya lo tenía. Esa misma tarde nos pusimos con las actividades. Super práctico y el contenido es hermoso.',
  name: 'Lucía H.'
}, {
  stars: 5,
  title: 'El mejor regalo que le di',
  text: 'Mi hijo me dijo "mami, ya sé leer" con la carita más orgullosa del mundo. Ese momento valió cada centavo. Lo volvería a comprar mil veces.',
  name: 'Andrea C.'
}];
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-141">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className={`w-[18px] h-[18px] ${i < count ? 'text-yellow-400 fill-yellow-400' : 'text-gray-200 fill-gray-200'}`} strokeWidth={0} data-id="element-142" />)}
    </div>;
}
export function ReviewsSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useScrollReveal();
  return <section className="pt-10 pb-12 px-4 bg-[#FAFAFA]" data-id="element-143">
      <div className="max-w-4xl mx-auto" data-id="element-144">
        <div className="text-center mb-10" data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3" data-id="element-146">
            Lo que otras madres dicen
          </h2>
          <p className="text-gray-500 text-base" data-id="element-147">
            Testimonios reales de mamás y papás que ya lo tienen
          </p>
        </div>

        {/* Screenshot testimonials */}
        <div ref={ref} className={`flex flex-col gap-4 max-w-2xl mx-auto mb-10 ${isVisible ? 'reveal-visible' : 'reveal-hidden'}`} data-id="element-148">
          {testimonialImages.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-149">
              <img src={testimonial.src} alt={testimonial.alt} className="w-full h-auto block" loading="lazy" data-id="element-150" />
            </div>)}
        </div>

        {/* Review cards grid */}
        <div ref={ref2} className={`grid grid-cols-2 gap-3 md:gap-5 ${isVisible2 ? 'reveal-visible' : 'reveal-hidden'}`} data-id="element-151">
          {reviews.map((review, index) => <div key={index} className="bg-white rounded-2xl p-4 md:p-6 border border-gray-100 shadow-sm" data-id="element-152">
              <StarRating count={review.stars} data-id="element-153" />
              <h3 className="font-bold text-gray-800 text-sm md:text-base mt-2 md:mt-3 mb-1 md:mb-2" data-id="element-154">
                {review.title}
              </h3>
              <p className="text-xs md:text-sm text-gray-600 leading-relaxed mb-3 md:mb-4" data-id="element-155">
                {review.text}
              </p>
              <p className="text-xs md:text-sm font-semibold text-gray-700" data-id="element-156">
                {review.name}{' '}
                <span className="font-normal text-green-600" data-id="element-157">
                  (Compra verificada ✓)
                </span>
              </p>
            </div>)}
        </div>

        <p className="text-center text-sm text-gray-400 mt-8" data-id="element-158">
          Capturas y reseñas reales de nuestros clientes ❤️
        </p>
      </div>
    </section>;
}